"use strict";
exports.__esModule = true;
;
var Spark = /** @class */ (function () {
    function Spark() {
        this.reducers = {};
        // -------- PRIVATE METHODS
    }
    // -------- PUBLIC INTERFACE
    /**
     * Save reducer internally.
     * Called by the reducer itself when it is created.
     *
     * @param reducerName - reducer's name.
     * @param reducer - reducer to be registered.
     */
    Spark.prototype.registerReducer = function (reducerName, reducer) {
        if (this.reducers[reducerName]) {
            throw new Error("Redux Spark - reducer \"" + reducerName + "\" already exists.");
        }
        this.reducers[reducerName] = reducer;
    };
    /**
     * Returns all of the registered reducers,
     * so they can be used in redux's combineReducers method.
     *
     * @return Map of all registered reducers.
     */
    Spark.prototype.getAllReducers = function () {
        var _this = this;
        var reducers = {};
        Object.keys(this.reducers).forEach(function (reducerName) {
            var reducer = _this.reducers[reducerName].getReducerFunction();
            reducers[reducerName] = reducer;
        });
        return reducers;
    };
    /**
     * Returns all of the generated sagas,
     * so they can be run using saga middleware.
     *
     * @return Array of all generated sagas.
     */
    Spark.prototype.getAllSagas = function () {
        var _this = this;
        var allSagas = [];
        Object.keys(this.reducers).forEach(function (reducerName) {
            var reducerSagas = _this.reducers[reducerName].getSagas();
            allSagas.push.apply(allSagas, reducerSagas.map(function (saga) { return saga(); }));
        });
        return allSagas;
    };
    return Spark;
}());
exports["default"] = new Spark();
